module.exports = __webpack_public_path__ + "img/texp.04c9ce4d.png";